module.exports = __webpack_public_path__ + "static/img/banner-img.64d71ff.png";


//////////////////
// WEBPACK FOOTER
// ./src/view/images/banner-img.png
// module id = x3q4
// module chunks = 1